// Manifest
import { manifest } from '../../../manifests/questionManifest';

const keysByName = new Map();
const namesByKey = new Map();

Object.entries(manifest).forEach(([staticKey, value]) => {
    keysByName.set(value.key, staticKey);
    namesByKey.set(staticKey, value.key);
});

export const useStaticKey = () => {
    const getStaticKeyByName = (name: string): string => keysByName.get(name);
    const getNameByStaticKey = (name: string): string => namesByKey.get(name);
    return {
        getStaticKeyByName,
        getNameByStaticKey,
        convertMapFromKeysToNames: (data: Record<string, any>) =>
            Object.entries(data).reduce(
                (acc, [name, val]) => ({
                    ...acc,
                    [getNameByStaticKey(name)]: val
                }),
                {}
            ),
        convertMapFromNamesToKeys: (data: Record<string, any>) =>
            Object.entries(data).reduce(
                (acc, [key, val]) => ({
                    ...acc,
                    [getStaticKeyByName(key)]: val
                }),
                {}
            )
    };
};

export default useStaticKey;
